import { Vector3 } from "three";
import { Assets } from "../Assets";
import { LevelObject } from "../LevelObject";
import { Obstacle } from "../components/Obstacle";
import { Updater } from "../components/Updater";
import { CookState, isCookable } from "../components/Cookable";
import { ParticleSystem } from "../ParticleSystem";
export class Grill extends Updater(Obstacle(LevelObject)) {
    constructor(levelMap, position) {
        super(levelMap, Assets.objects.Grill.clone(), position);
        this.shelfHeight = 0.72;
        this.particles = new ParticleSystem({
            texture: Assets.textures.smoke,
            position: new Vector3(0, 1, 0),
            emitsPerStep: 0.5,
            particleLife: 10,
            size: 0.25,
            sizeSpread: 0.2,
            positionSpread: [0.5, 0.1, 0.5],
            alpha: 0.3,
        });
        this.model.add(this.particles.mesh);
    }
    update(step, duration) {
        this.particles.update(step);
    }
    endStep(step) {
        const object = this.levelMap.getLooseObject(this.tilePos);
        if (object && isCookable(object)) {
            this.particles.updateSettings({
                emitsPerStep: 3,
                color: object.cookState === CookState.Burnt ? [0.3, 0.3, 0.3] : [1, 1, 1],
            });
            object.cook();
        }
        else {
            this.particles.updateSettings({
                emitsPerStep: 0.5,
                color: [1, 1, 1],
            });
        }
    }
    static get type() {
        return 'grill';
    }
}
